import { string, object, date } from "yup";
import { isDate } from "date-fns";
import dayjs from "dayjs";

const parseDateString = (originalValue) => {
  const parsedDate = isDate(originalValue)
    ? originalValue
    : new Date(dayjs(originalValue));
  return parsedDate;
};

const validationSchema = object().shape({
  name: string().required("Project Name is required"),
  description: string(),
  projectCategoryId: string().required("Project type is required"),
  endDate: date()
    .typeError("End date is required")
    .transform(parseDateString)
    .required("End date is required"),
});

export default validationSchema;
